import { render, staticRenderFns } from "./BelposhtaCreation.vue?vue&type=template&id=04217166&scoped=true"
import script from "./BelposhtaCreation.vue?vue&type=script&lang=js"
export * from "./BelposhtaCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04217166",
  null
  
)

export default component.exports